module.exports = __webpack_public_path__ + "img/b6.67739a3f.png";